import { getEnvironment } from "../utils";
/**
 * Plugin helper para determinar en entorno por URL e inyectar la
 * libreria de Launch apropiada ya que por entorno es imposible
 * controlarlo por Jenkins
 */
const AdobeLaunch = {
  install(Vue) {
    const environment = getEnvironment();

    const scriptElement = document.createElement("script");
    scriptElement.src = environment.adobeLaunch;
    scriptElement.async = true;
    scriptElement.defer = true;

    document.head.appendChild(scriptElement);
    Vue.$log.info("AdobeLaunch inyectada", environment.description);
  }
};

export default AdobeLaunch;
